import type { FaireProductEntity } from "../../entity_types/product";

export const p_jvkgzpkqkg: FaireProductEntity = {
  token: "p_jvkgzpkqkg",
  type: "product",
  name: "Onyx Bow Tutu Skirt - Kids Boutique Clothing - Halloween",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/126a1e67002d3f81d5ff38e01ad3c275deff379d2975f3fde8cdc91b6cecf53b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dc070a560bf5d0565e2c5151340ce77ed291663df5902300205ddf81740f0b00.jpeg",
    "https://cdn.faire.com/fastly/6db513331e604d6dcb83ddc88d8c63723baeb80b06a9a236e219be7b1749f67d.jpeg",
    "https://cdn.faire.com/fastly/69e3a00148005807aaccdab35170797f1bec98c303cebb2dd312680e6f9b06a4.jpeg",
    "https://cdn.faire.com/fastly/a1c19aac20574e8c8f2aafdf1dc815f392aeebed71da138222945424cbd70f76.jpeg",
    "https://cdn.faire.com/fastly/9f76fe4503be588fa81bc559cdc2492e1e5e9c9a3a7d6b8cea17e409b4cd8920.jpeg",
    "https://cdn.faire.com/fastly/b5e4000e201dac7929be2904dcac29da8364bd3973eafc791aaf22f3be482243.jpeg",
    "https://cdn.faire.com/fastly/4d5fa3c52b632bff0a587c4c5496209bc99ee7c3cfaeea0a122982b26f3b3cdc.jpeg",
  ],
  priceDollars: 18,
  description:
    "Made for twirling through spooky season, this dreamy black tutu features darling bow details for an extra touch of Halloween magic.\n\nFeatures:\n * Black tulle accented with black satin bows and silver glitter pin dots \n * Black cotton lining \n * Black glitter elastic waistband \n * Care: Hand wash and line dry \n\nThe Sweet Wink difference:\n * Super soft tulle that doesn’t scratch or itch \n * Cotton lining provides extra coverage and comfort \n * “Shed-free” embellishments ensure glitter does not sprinkle around the house ",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:34:30.754Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
